module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_0.49374a0c.png";